
import PricingButton from "@/components/main/pricing/PricingButton";
import RedHeadBox from "@/components/main/core/RedHeadBox";
import SearchCircle from "@/components/main/core/SearchCircle"

import cam4 from "@/assets/images/main/example/cam/cam4.png"
import camscom from "@/assets/images/main/example/cam/camscom.png"
import extreme from "@/assets/images/main/example/cam/extreme.png"
import home from "@/assets/images/main/example/cam/home.png"
import keezlive from "@/assets/images/main/example/cam/keezlive.png"
import kink from "@/assets/images/main/example/cam/kink.png"
import live from "@/assets/images/main/example/cam/live.png"
import porntube from "@/assets/images/main/example/cam/porntube.png"
import streamate from "@/assets/images/main/example/cam/streamate.png"
import tube8 from "@/assets/images/main/example/cam/tube8.png"
import isMobile from "@/mixins/isMob";

import data from "@/mixins/data";
import gsap from "gsap";
export default {
  name: "CamStreamsTab",
  components: { PricingButton, RedHeadBox, SearchCircle, isMobile},
  mixins: [data, isMobile],
  data() {
    return {
      date: new Date(),
      complete: false,
      camServices: [
        {
          logo: cam4,
          isFound: true,
          email: 'name@email.com',
          service: 'cam4.com'
        },
        {
          logo: camscom,
          isFound: false,
          email: '',
          service: 'camscom.com'
        },
        {
          logo: extreme,
          isFound: true,
          email: 'name@email.com',
          service: 'extremetube.com'
        },
        {
          logo: home,
          isFound: false,
          email: '',
          service: 'homegrowncams.com'
        },
        {
          logo: keezlive,
          isFound: true,
          email: 'name@email.com',
          service: 'keezlive.com'
        },
        {
          logo: kink,
          isFound: false,
          email: '',
          service: 'kinklive.com'
        },
        {
          logo: live,
          isFound: false,
          email: '',
          service: 'itslive.com'
        },
        {
          logo: porntube,
          isFound: true,
          email: 'name@email.com',
          service: 'porntube.com'
        },
        {
          logo: streamate,
          isFound: false,
          email: '',
          service: 'streamate.com'
        },
        {
          logo: tube8,
          isFound: true,
          email: 'name@email.com',
          service: 'tube8.com'
        },
      ]
    }
  },
  methods: {
    datenow() {
      if (this.date.getMinutes())
        return `${this.date.getDate()}/${this.date.getMonth()+1}/${this.date.getFullYear()} ${this.date.getHours()}:${+this.date.getMinutes() <= 10 ? '0'+this.date.getMinutes() : this.date.getMinutes()}`
    },

    beforeEnter(el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(60px)'
    },

    enter(el) {
      gsap.to(el, {
        opacity: 1,
        y: 0,
        duration: 1,
        delay: el.dataset.index*0.6
      })
    },

    end(is) {
      this.complete = is;
    }
  }
}
